import type { IApiReportDetailResp } from '@/services/swagger/easourcing/models';
import type { ParsedContentBlocks, ReportContentBlock, ReportDetailData } from '../card/store-types';

/**
 * 将 IApiReportDetailResp 转换为 ReportDetailData。
 * 核心差异：contentBlocks 从 JSON 字符串解析为 ReportContentBlock[] 数组；
 * - 后端直接下发数组时直接使用
 * - 后端下发 { meta, blocks, sources } 对象时提取 blocks
 * parse 失败时以空数组降级，不抛出异常。
 */
export function transformApiReportDetail(resp: IApiReportDetailResp): ReportDetailData {
  let contentBlocks: ReportContentBlock[];

  try {
    const parsed = JSON.parse(resp.contentBlocks ?? '[]') as ParsedContentBlocks;
    if (Array.isArray(parsed)) {
      // 后端直接下发 ReportContentBlock[] 数组
      contentBlocks = parsed;
    } else {
      // 后端下发 { meta, blocks, sources } 对象，提取 blocks
      contentBlocks = Array.isArray(parsed.blocks) ? parsed.blocks : [];
    }
  } catch {
    contentBlocks = [];
  }

  return {
    ...resp,
    contentBlocks,
  };
}
